import Data from '../config/topicData';
import versionData from '../config/version';
import method from '../commonjs/method';
let partnerCode = 'JS_CMCC_CP';
let userMac = '08:a5:c8:d5:cf:5b';
let tokenCode = '';
let userToken = '';
let userId = "";//1393712007301
let userSTBID = "";//默认为盒子硬件序列号，基地项目为基地指定ID，sn：设备序列ID归为STBID（原点播A=0,1含此参数）
let apkv = '2.0.96';
let currentdate;
let epgServer = "http://221.180.188.26:33200";
let H5V = versionData.list[0].version;
let PBls = 0;
let appSI = "37";
if(window._APP){
     partnerCode = window._APP.getPartnerCode();

    if(window._APP.getDataSource){
      appSI = window._APP.getDataSource();
    }
    tokenCode = window._APP.getToken();
     console.log("tokenCode112----"+tokenCode)
    userId = window._APP.getUserId();

    userMac = window._APP.getMac();
    apkv = window._APP.getVersion();
    //userSTBID= window._APP.getStbID();
    epgServer = window._APP.getEpgServer();
    userToken = window._APP.getUserToken();

    if(userId === ''){
        userId = userMac;
    }
}
let getTime = () => {
    let date = new Date();
    let month = date.getMonth() + 1;
    let strDate = date.getDate();
    let strHour = date.getHours();
    let strMin = date.getMinutes();
    let strSec = date.getSeconds();
    if (month >= 1 && month <= 9) {
        month = "0" + month;
    }
    if (strDate >= 0 && strDate <= 9) {
        strDate = "0" + strDate;
    }
    if (strHour >= 0 && strHour <= 9) {
        strHour = "0" + strHour;
    }
    if (strMin >= 0 && strMin <= 9) {
        strMin = "0" + strMin;
    }
    if (strSec >= 0 && strSec <= 9) {
        strSec = "0" + strSec;
    }
      PBls++;
    currentdate = date.getFullYear() +' '+ month +' '+ strDate +' '+ strHour +' '+ strMin +' '+ strSec;
    currentdate = currentdate.replace(/\s/g,"");
}
export default {
    getPBEnter(obj,tmt){// get  pb参数
        getTime();
        let basics = {
          PV:"5.3.9",
          apppag:method.getValue("apppag")?method.getValue("apppag"):"_",
          position:method.getValue("position")?method.getValue("position"):"_",
          V:apkv,
          P:partnerCode,
          TS:currentdate,
          MC:userMac,
          A:"32",
          h5v:H5V,
          si:appSI,
          userId:userId,
          tmt:tmt,
          ls:PBls
      };
        let data = Object.assign({},basics,obj); // 合并对象
        let json = "";
         for(let key in data) {
            if(data[key] == ""){//值是否为空
              continue;
            }
            json += key+"="+data[key]+"&";
        }
        let jsonData = json.substring(0,json.length-1);
        let reqUrl = "https://pb-h5.gitv.tv/vod_pb/v?"+jsonData;
        method.getSendPB(reqUrl);
        console.log("executeRequest PB"+reqUrl);
        return reqUrl;
    },
    getAppPBEnter(obj){// get  pb参数
        getTime();
        let basics = {PV:"5.3.9",A:"32",si:appSI,TS:currentdate,h5v:H5V,tmt:"1",ls:PBls,pat:"问卷调查H5"};
        let data = Object.assign({},basics,obj); // 合并对象
        let json = "";
         for(let key in data) {
            if(data[key] == ""){//值是否为空
              continue;
            }
            json += key+"="+data[key]+"&";
        }
        let jsonData = json.substring(0,json.length-1);
        let reqUrl = "https://pb-h5.gitv.tv/vod_pb/v?"+jsonData;
        method.getSendPB(reqUrl);
        console.log("executeRequest PB"+JSON.stringify(jsonData));
        return reqUrl;
    },

    getStatusUrlPost:{//鉴权接口 {epgServer:"221.180.188.26:33200",mac:"50:01:6b:2c:36:c4",userId:"842C80325D27",userToken:"7N04d7N04d5kyezk32ItoYIHJGRE4XCf"}
       urlData:{
        path:"",
        data:{epgServer:epgServer+"",mac:userMac,userId:userId,userToken:userToken,activityId:"yxdd1029"}
      }
    },
    h5PagePositionList(pageNo){//H5专题---活动页面位置列表
        const reqUrl = Data[partnerCode].interface+`/h5PagePositionList/${method.getValue("screenId")}/${pageNo}/?partnerCode=${partnerCode}&token=${tokenCode}`;
        console.log("h5PagePositionList----"+reqUrl)
        return reqUrl;
    },
    h5PageList(positionId,pageNo){//H5专题---专题活动页面列表接口 positionId:位置id(从h5PagePositionList获取的positionType=2时)
        const reqUrl = Data[partnerCode].interface+`/h5PageList/${positionId}/${pageNo}/?partnerCode=${partnerCode}&token=${tokenCode}`;
        console.log("h5PageList----"+reqUrl)
        return reqUrl;
    },
    h5PagePopupList(pageNo){//H5专题---专题活动弹窗列表 screenId:屏幕id
        const reqUrl = Data[partnerCode].interface+`/h5PagePopupList/${method.getValue("screenId")}/${pageNo}/?partnerCode=${partnerCode}&token=${tokenCode}`;
        console.log("h5PagePopupList----"+reqUrl)
        return reqUrl;
    }
}



// WEBPACK FOOTER //
// ./src/commonjs/urlConfiger.js